"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTaskTable = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _dmsbasereact = require("dmsbasereact");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _ToggleOn = _interopRequireDefault(require("@mui/icons-material/ToggleOn"));
var _ToggleOff = _interopRequireDefault(require("@mui/icons-material/ToggleOff"));
var _Permissions = require("../../constants/Permissions");
var _AlertConstants = require("../../constants/AlertConstants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsTaskTable = () => {
  const table = (0, _react.useRef)(null);
  const onToggleStatus = async item => {
    const current = item.is_active;
    const isActive = current === true || current === '1' || current === 1 || String(current).toLowerCase() === 'true';
    const newStatus = !isActive;
    const result = await _sweetalert.default.fire({
      title: _reactIntlUniversal.default.get("ConfirmToggle").d("Change active status?"),
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: _reactIntlUniversal.default.get("Yes").d("Yes"),
      cancelButtonText: _reactIntlUniversal.default.get("No").d("No")
    });
    if (!result.isConfirmed) return;
    try {
      const url = "/alert_task/active/".concat(item.pk, "?is_active=").concat(newStatus);
      const response = await (0, _dmsbasereact.fetchData)(url, "PUT", true);
      if (response.status === _dmsbasereact.HTTP_STATUS.OK_200) {
        table.current.updateTable();
        _sweetalert.default.fire({
          icon: 'success',
          title: _reactIntlUniversal.default.get("StatusUpdated").d("Status updated")
        });
      } else {
        var _response$data;
        _sweetalert.default.fire({
          icon: 'error',
          title: (response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.detail) || 'Error'
        });
      }
    } catch (err) {
      _sweetalert.default.fire({
        icon: 'error',
        title: err.message || String(err)
      });
    }
  };
  const header = [{
    label: _reactIntlUniversal.default.get("AlertMessage").d("Alert Message"),
    column_name: "alert_message_pk",
    control: 'select',
    url: "/alert_message/all",
    properties: {
      column_name: "alert_message_pk",
      text_template: '{title}',
      label: "title",
      value: "pk",
      filter: {
        field: 'alert_message_pk',
        value: 'pk'
      }
    },
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Snooze").d("Snooze"),
    column_name: "snooze",
    map: Object.fromEntries(Object.entries(_AlertConstants.SnoozeTypesEnum).map(_ref => {
      let [key, value] = _ref;
      return [value, key];
    })),
    options: Object.fromEntries(Object.entries(_AlertConstants.SnoozeTypesEnum).map(_ref2 => {
      let [key, value] = _ref2;
      return [value, key];
    })),
    control: 'select',
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("DateTimeBegin").d("Date Time Begin"),
    column_name: "date_time_begin",
    function: date => (0, _moment.default)(date).format("DD/MM/YYYY HH:mm:ss"),
    control: 'datetime',
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("IsActive").d("Is Active"),
    column_name: "is_active",
    control: 'switch',
    function: (value, item) => {
      const current = item.is_active;
      const boolVal = current === true || current === '1' || current === 1 || String(current).toLowerCase() === 'true';
      return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsButton, {
        onClick: () => onToggleStatus(item),
        icon: item.is_active ? /*#__PURE__*/_react.default.createElement(_ToggleOn.default, null) : /*#__PURE__*/_react.default.createElement(_ToggleOff.default, null),
        variant: item.is_active ? 'success' : 'danger'
      });
    },
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    permissions: _Permissions.Permissions.CAN_EDIT_ALERT_TASK,
    column_name: "actions",
    sortable: false,
    can_edit: false,
    can_create: false,
    element: row => {
      const name = row.name;
      return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Update_name", {
          name
        }).d("Update {name}"),
        url: "/alert_task/",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Delete_name", {
          name
        }).d("Delete {name}"),
        text: _reactIntlUniversal.default.get("DmsAlertTable.DeleteButtonMessage", {
          name
        }).d("The alert {name} will be deleted. Are you sure about it?"),
        url: "/alert_task/",
        row_pk: row.pk
      }));
    }
  }];
  const createAlert = async data => {
    const url = "/alert_task";
    if (data && Object.prototype.hasOwnProperty.call(data, 'is_active')) {
      const v = data.is_active;
      const isActiveBool = v === true || v === '1' || v === 1 || String(v).toLowerCase() === 'true';
      data.is_active = isActiveBool;
    }
    if (data && Object.prototype.hasOwnProperty.call(data, 'snooze')) {
      const s = data.snooze;
      const raw = s && typeof s === 'object' && Object.prototype.hasOwnProperty.call(s, 'value') ? s.value : s;
      const n = Number(raw);
      if (!Number.isNaN(n)) {
        data.snooze = n;
      } else {
        const pi = parseInt(String(raw), 10);
        if (!Number.isNaN(pi)) data.snooze = pi;
      }
    }
    const response = await (0, _dmsbasereact.fetchData)(url, "POST", true, data);
    if (response.status === _dmsbasereact.HTTP_STATUS.CREATED_201) {
      table.current.updateTable();
      _sweetalert.default.fire({
        icon: "success",
        title: _reactIntlUniversal.default.get("AlertCreated").d("Alert Created")
      });
    } else {
      var _response$data2;
      _sweetalert.default.fire({
        icon: "error",
        title: response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.detail
      });
    }
  };
  const toolbar = /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_ALERT_TASK
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTableCreateButton, {
    header: header,
    table: table,
    handler: createAlert,
    title: _reactIntlUniversal.default.get("CreateAlert").d("Create Alert")
  }))));
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: "/alert_task/table",
    export_table: false,
    toolbar: toolbar,
    responsive: true
  });
};
exports.DmsTaskTable = DmsTaskTable;